import React, { useEffect, useRef, useState } from "react";
import { colors } from '../../../theme/colors';
import { BootstrapDialog, HomeContainer } from "./style";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  Chip,
  TextField,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Checkbox,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import DescriptionIcon from "@mui/icons-material/Description";
import _ from "lodash";
import {
  useCreateNewJobDescription,
  useMatchingProcessallResumes,
  useMatchingProcessTopResumes,
  useUploadJobDescriptionsAndResumes,
  useGetDetaileResume,
  useDownloadResumeList,
  useBulkResumeUpload,
} from "../../../store/query/pythonQuery";
import CommonSnackbar from "../../../components/common-components/CommonSnackbar";
import CandidateSummary from "./CandidateSummary";
import CreateNewJobDescription from "./CreateNewJobDescription";
import classNames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import ReactMarkdown from "react-markdown";
import { axiosInstance } from "../../../utils/axiosInstance";
import { JobEndPoint, SavedCandidateEndPoint } from "../../../api-routes";

const Home = () => {
  const navigate = useNavigate();
  const pdfRef = useRef(null);
  const resumeRef = useRef(null);
  const resultSectionRef = useRef(null);
  const [jobDescription, setJobDescription] = useState(null);
  const [resume, setResume] = useState([]);
  const [category, setCategory] = useState("match_resume");
  const [result, setResult] = useState([]);
  const [summary, setSummary] = useState([]);
  const [newJDDescriptions, setNewJDDescriptions] = useState("");
  const [alertDetail, setAlertDetail] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [backDrop, setBackDrop] = useState(false);
  const [tab, setTab] = useState("matching");
  const [jdDetails, setJdDetails] = useState(null);
  const [detailedSummary, setDetailedSummary] = useState(null);
  const [jdLevel, setjdLevel] = useState(null);
  const [yearExperiencesList, setyearExperiencesList] = useState([]);
  const [location, setLocation] = useState("");
  const [year, setYear] = useState(null);
  const [resumeId, setResumeId] = useState(null);
  const [jdResumeSessionId, setJdResumeSessionId] = useState(null);
  const [openMatchingExplanationDialog, setOpenMatchingExplanationDialog] =
    useState(false);
  const [selectedExplanation, setSelectedExplanation] = useState("");
  const [selectedRecommendation, setSelectedRecommendation] = useState("");
  const [jdMode, setJdMode] = useState("upload");
  const [jobSearch, setJobSearch] = useState("");
  const [activeJobs, setActiveJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobSearchLoading, setJobSearchLoading] = useState(false);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [savingCandidates, setSavingCandidates] = useState(false);
  const [uploadModeJobs, setUploadModeJobs] = useState([]);
  const [uploadModeJobSearch, setUploadModeJobSearch] = useState("");
  const [uploadModeJobLoading, setUploadModeJobLoading] = useState(false);
  const uploadCombinedFilesMutation = useUploadJobDescriptionsAndResumes();
  const matchingProcessallResumeMutations = useMatchingProcessallResumes();
  const bulkResumeUploadMutation = useBulkResumeUpload();
  const matchingProcessTopResumesMutation = useMatchingProcessTopResumes();
  const createNewJobDescriptionMutation = useCreateNewJobDescription();
  const getDetaileResumeMutation = useGetDetaileResume();
  const downloadResumeListMutation = useDownloadResumeList();

  useEffect(() => {
    setSelectedCandidates([]);
    if (result?.length > 0 && resultSectionRef.current) {
      setTimeout(() => {
        resultSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [result]);

  useEffect(() => {
    if (jdMode !== "select") return;
    const showLoading = activeJobs.length === 0;
    if (showLoading) setJobSearchLoading(true);
    const timer = setTimeout(async () => {
      try {
        const res = await axiosInstance.get(
          JobEndPoint.SEARCH_ACTIVE_JOBS + `?search=${jobSearch}`,
        );
        setActiveJobs(res.data.data || []);
      } catch (err) {
        console.error("Failed to search jobs", err);
      } finally {
        setJobSearchLoading(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [jobSearch, jdMode]);

  useEffect(() => {
    if (jdMode !== "upload" || selectedCandidates.length === 0) return;
    const timer = setTimeout(async () => {
      setUploadModeJobLoading(true);
      try {
        const res = await axiosInstance.get(
          JobEndPoint.SEARCH_ACTIVE_JOBS + `?search=${uploadModeJobSearch}`,
        );
        setUploadModeJobs(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch jobs for dropdown", err);
      } finally {
        setUploadModeJobLoading(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [uploadModeJobSearch, jdMode, selectedCandidates.length]);

  const handleSelectExistingJob = async (job) => {
    setSelectedJob(job);
    setBackDrop(true);
    try {
      const res = await axiosInstance.get(
        `${JobEndPoint.GET_JD_FILE}/${job._id}/jd-file`,
        { responseType: "blob" },
      );
      const file = new File(
        [res.data],
        job.jdFileName || "job-description.pdf",
        {
          type: res.data.type,
        },
      );
      setJobDescription(file);
      setResult([]);
      setDetailedSummary(null);
    } catch (err) {
      console.error("Failed to fetch JD file", err);
      setAlertDetail({
        open: true,
        message: "Failed to load JD file for selected job",
        severity: "error",
      });
      setSelectedJob(null);
    } finally {
      setBackDrop(false);
    }
  };

  const getTableRowColor = (value) => {
    return classNames({
      color_green: value >= "60",
      color_red: value < "60",
    });
  };

  const level = [
    { value: "Junior", label: "Junior" },
    { value: "Middle", label: "Middle" },
    { value: "Senior", label: "Senior" },
    { value: "Leadership", label: "Leadership" },
  ];
  const years = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
  ];
  const headCells = [
    { label: "Full Name", width: "120px" },
    { label: "Contact Details", width: "160px" },
    { label: "Experience", width: "180px" },
    { label: "Skills", width: "200px" },
    { label: "Education", width: "150px" },
    { label: "Matching %", width: "90px" },
    { label: "Matching Explanation", width: "280px" },
    { label: "Detailed Summary", width: "100px" },
  ];
  const handleChangeTab = (__, newValue) => {
    setTab(newValue);
    console.log(newValue);
  };
  const handleSelectPDF = () => {
    pdfRef.current.click();
  };
  const handleOpenResume = () => {
    resumeRef.current.click();
  };

  const handleFileChange = (e) => {
    setResult([]);
    setDetailedSummary(null);
    const file = e.target.files[0];
    if (file) {
      setJobDescription(file);
    }
  };

  const handleSelectResume = (e) => {
    setResult([]);
    setDetailedSummary(null);
    const files = e.target.files;
    const resumes = [];
    _.forEach(files, (value, key) => {
      resumes.push(value);
    });
    const resumeList = [...resume, ...resumes];
    setResume(resumeList);
  };
  const handleRemoveResume = (id) => {
    const filterResume = _.filter(resume, (value, key) => {
      return key !== id;
    });
    setResume(filterResume);
    setResult([]);
    setDetailedSummary(null);
  };
  const handleGenerateResult = () => {
    if (jobDescription === null || resume.length === 0) {
      setAlertDetail({
        open: true,
        message: "Please upload a job description and at least one resume",
        severity: "error",
      });
      return;
    }
    setBackDrop(true);
    if (category === "match_resume") {
      const formData = new FormData();
      Array.from(resume).forEach((file, index) => {
        formData.append(`files`, file);
      });
      formData.append("fileID", JSON.stringify(resumeId));
      formData.append("sessionID", jdResumeSessionId);
      bulkResumeUploadMutation.mutate(formData, {
        onSuccess: (data) => {
          const failedUploads = data?.all_resumes?.filter(
            (resume) => !resume.stored_in_pinecone,
          );
          const successUploads = data?.all_resumes?.filter(
            (resume) => resume.stored_in_pinecone,
          );
          if (failedUploads.length > 0) {
            const failedFiles = failedUploads.map(
              (resume) => resume["Full Name"],
            );
            setAlertDetail({
              open: true,
              message:
                failedFiles.length === 1
                  ? `Error: This resume is already uploaded: ${failedFiles[0]}`
                  : `Error: These resumes are already uploaded: ${failedFiles.join(
                      ", ",
                    )}`,
              severity: "error",
            });
          }
          if (failedUploads.length === 0 && successUploads.length === 0) {
            setAlertDetail({
              open: true,
              message:
                "Error: No resumes were uploaded. Please check the files.",
              severity: "error",
            });
          }
          setResult(data?.all_resumes);
          setJdResumeSessionId(data?.session_id);
          setBackDrop(false);
        },

        onError: (error) => {
          console.log(error);
          setBackDrop(false);
          setAlertDetail({
            open: true,
            message: "Please select job description, resumes and matching",
            severity: "error",
          });
        },
      });
    } else {
      matchingProcessTopResumesMutation.mutate(_, {
        onSuccess: (data) => {
          setResult(data?.top_resumes);
          setSummary(data?.summary);
          setBackDrop(false);
        },
        onError: (error) => {
          console.log(error);
          setBackDrop(false);
          setAlertDetail({
            open: true,
            message: "Please select job description, resumes and matching",
            severity: "error",
          });
        },
      });
    }
  };
  const handleCheckCategory = (e) => {
    const { value } = e.target;
    setResult([]);
    setSummary([]);
    setDetailedSummary(null);
    setCategory(value);
  };
  const handleCreateNewJD = () => {
    setBackDrop(true);
    createNewJobDescriptionMutation.mutate(
      {
        prompt: newJDDescriptions,
        level: jdLevel?.value === "Leadership" ? "leadership" : jdLevel?.value,
        location: location,
        years: jdLevel?.value === "Leadership" ? null : year?.value,
      },
      {
        onSuccess: (data) => {
          setJdDetails(data);
          setBackDrop(false);
        },
        onError: (error) => {
          setBackDrop(false);
        },
      },
    );
  };
  const handleSetNewJDDescription = (event) => {
    const { value } = event.target;
    setNewJDDescriptions(value);
  };
  const handleSetLocation = (event) => {
    const { value } = event.target;
    setLocation(value);
  };
  const handleGetDetailedResume = (candidateId, jdResumeSessionId) => {
    setBackDrop(true);

    getDetaileResumeMutation.mutate(
      { candidateId, jdResumeSessionId },
      {
        onSuccess: (data) => {
          setBackDrop(false);
          setDetailedSummary(data);
          let summaryDiv = document.getElementById("summary__heading");
          if (summaryDiv) {
            summaryDiv.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        },
        onError: (error) => {
          setBackDrop(false);
        },
      },
    );
  };

  const handleUploadFiles = () => {
    setBackDrop(true);

    const formData = new FormData();
    formData.append("jd", jobDescription);

    Array.from(resume).forEach((file) => {
      formData.append("resumes", file);
    });

    uploadCombinedFilesMutation.mutate(formData, {
      onSuccess: (response) => {
        setBackDrop(false);
        const session_Id = response?.session_id;
        setResumeId(response?.uploaded_resumes);
        setJdResumeSessionId(session_Id);
      },
      onError: (error) => {
        setBackDrop(false);
        console.log(error);
        setAlertDetail({
          open: true,
          message:
            error.response?.data?.detail ||
            "Error uploading files. Please try again",
          severity: "error",
        });
      },
    });
  };

  const handleMatchingExplanation = (explanation, recommendation) => {
    setSelectedExplanation(explanation);
    setSelectedRecommendation(recommendation || "");
    setOpenMatchingExplanationDialog(true);
  };
  const handleClose = () => {
    setOpenMatchingExplanationDialog(false);
  };

  const handleToggleCandidate = (index) => {
    setSelectedCandidates((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  const handleToggleAllCandidates = () => {
    if (selectedCandidates.length === result.length) {
      setSelectedCandidates([]);
    } else {
      setSelectedCandidates(result.map((_, i) => i));
    }
  };

  const handleSaveSelected = async () => {
    if (selectedCandidates.length === 0) return;

    const role =
      selectedJob?.roleDesignation ||
      (jobDescription
        ? jobDescription.name.replace(/\.[^/.]+$/, "")
        : "Unknown Role");

    const candidates = selectedCandidates.map((index) => {
      const r = result[index];
      return {
        candidateName: r["Full Name"],
        matchScore: Number(r["Percentage Matching"]) || 0,
        role,
        job_id: selectedJob?.jobId || "",
        email: r.Email || "",
        sessionId: jdResumeSessionId || "",
      };
    });

    setSavingCandidates(true);
    try {
      await axiosInstance.post(SavedCandidateEndPoint.SAVE_CANDIDATES, {
        candidates,
      });
      setSelectedCandidates([]);
      navigate("/app/selected");
    } catch (err) {
      console.error("Failed to save candidates", err);
      setAlertDetail({
        open: true,
        message: err.response?.data?.message || "Failed to save candidates",
        severity: "error",
      });
    } finally {
      setSavingCandidates(false);
    }
  };

  const handleUploadModeSaveWithJob = async (job) => {
    if (selectedCandidates.length === 0 || !job) return;

    const candidates = selectedCandidates.map((index) => {
      const r = result[index];
      return {
        candidateName: r["Full Name"],
        matchScore: Number(r["Percentage Matching"]) || 0,
        role: job.roleDesignation || "Unknown Role",
        job_id: job.jobId || "",
        email: r.Email || "",
        sessionId: jdResumeSessionId || "",
      };
    });

    setSavingCandidates(true);
    try {
      await axiosInstance.post(SavedCandidateEndPoint.SAVE_CANDIDATES, {
        candidates,
      });
      setSelectedCandidates([]);
      navigate("/app/selected");
    } catch (err) {
      console.error("Failed to save candidates", err);
      setAlertDetail({
        open: true,
        message: err.response?.data?.message || "Failed to save candidates",
        severity: "error",
      });
    } finally {
      setSavingCandidates(false);
    }
  };

  useEffect(() => {
    if (jobDescription && resume.length) {
      handleUploadFiles();
    }
  }, [jobDescription, resume]);

  return (
    <HomeContainer>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openMatchingExplanationDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, color: colors.primary, fontWeight: 700 }}
          id="customized-dialog-title"
        >
          Matching Explanation
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Box sx={{ "& p": { margin: 0 } }}>
            <ReactMarkdown>{selectedExplanation || ""}</ReactMarkdown>
          </Box>
          {selectedRecommendation && (
            <Box
              sx={{
                mt: 2,
                pl: 2,
                borderLeft: `4px solid ${colors.primary}`,
                color: "text.secondary",
                "& p": { margin: 0, display: "inline" },
                "& strong": { fontWeight: 700 },
              }}
            >
              <Typography
                component="span"
                sx={{
                  fontWeight: "bold",
                  fontStyle: "italic",
                  color: colors.primary,
                }}
              >
                Recommend:{" "}
              </Typography>
              <Box
                component="span"
                sx={{ "& p": { margin: 0, display: "inline" } }}
              >
                <ReactMarkdown>{selectedRecommendation}</ReactMarkdown>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>

      <CommonSnackbar
        open={alertDetail.open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        setOpen={setAlertDetail}
        message={alertDetail.message}
        severity={alertDetail.severity}
      />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={backDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {tab === "matching" && (
        <Box className="tab__container">
          <Box className="step-flow">
            <Box
              className={`step-flow__step ${
                jobDescription
                  ? "step-flow__step--done"
                  : !jobDescription &&
                    resume.length === 0 &&
                    result.length === 0
                  ? "step-flow__step--active"
                  : "step-flow__step--pending"
              }`}
            >
              <Box className="step-flow__number">
                {jobDescription ? "✓" : "1"}
              </Box>
              <Box>
                <Typography className="step-flow__title">
                  Job Description
                </Typography>
                <Typography className="step-flow__subtitle">
                  {jobDescription ? "Uploaded ✓" : "Upload JD"}
                </Typography>
              </Box>
            </Box>

            <Box
              className={`step-flow__connector ${
                jobDescription ? "step-flow__connector--done" : ""
              }`}
            />

            <Box
              className={`step-flow__step ${
                resume.length > 0
                  ? "step-flow__step--done"
                  : jobDescription
                  ? "step-flow__step--active"
                  : "step-flow__step--pending"
              }`}
            >
              <Box className="step-flow__number">
                {resume.length > 0 ? "✓" : "2"}
              </Box>
              <Box>
                <Typography className="step-flow__title">
                  Bulk Resumes
                </Typography>
                <Typography className="step-flow__subtitle">
                  {resume.length > 0
                    ? `${resume.length} uploaded ✓`
                    : "Upload resumes"}
                </Typography>
              </Box>
            </Box>

            <Box
              className={`step-flow__connector ${
                resume.length > 0 && jobDescription
                  ? "step-flow__connector--done"
                  : ""
              }`}
            />

            <Box
              className={`step-flow__step ${
                result.length > 0
                  ? "step-flow__step--done"
                  : jobDescription && resume.length > 0
                  ? "step-flow__step--active"
                  : "step-flow__step--pending"
              }`}
            >
              <Box className="step-flow__number">
                {result.length > 0 ? "✓" : "3"}
              </Box>
              <Box>
                <Typography className="step-flow__title">
                  Run Matching
                </Typography>
                <Typography className="step-flow__subtitle">
                  {result.length > 0 ? "Completed ✓" : "AI scoring"}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box className="upload-sections">
            <Box className="upload-card">
              <Box className="upload-card__header">
                <DescriptionIcon sx={{ fontSize: 22, color: colors.primary }} />
                <Typography className="upload-card__heading">
                  Job Selection & Description
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 0,
                  mb: 2,
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  overflow: "hidden",
                  width: "fit-content",
                  mx: "auto",
                }}
              >
                <Button
                  onClick={() => {
                    if (jdMode === "select") return;
                    setJdMode("select");
                    setJobDescription(null);
                    setSelectedJob(null);
                    setResult([]);
                    setDetailedSummary(null);
                  }}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 0,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "13px",
                    backgroundColor:
                      jdMode === "select" ? "#eef2f7" : "transparent",
                    color: jdMode === "select" ? colors.primary : "#637381",
                    "&:hover": { backgroundColor: "#eef2f7" },
                  }}
                >
                  Select Existing Job
                </Button>
                <Button
                  onClick={() => {
                    if (jdMode === "upload") return;
                    setJdMode("upload");
                    setSelectedJob(null);
                    setJobDescription(null);
                    setResult([]);
                    setDetailedSummary(null);
                  }}
                  sx={{
                    px: 3,
                    py: 1,
                    borderRadius: 0,
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "13px",
                    backgroundColor:
                      jdMode === "upload" ? "#eef2f7" : "transparent",
                    color: jdMode === "upload" ? colors.primary : "#637381",
                    "&:hover": { backgroundColor: "#eef2f7" },
                  }}
                >
                  Upload JD
                </Button>
              </Box>

              {jdMode === "select" && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#333",
                      mb: 1,
                    }}
                  >
                    Search Active Jobs
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="e.g., Senior Frontend Engineer"
                    value={jobSearch}
                    onChange={(e) => setJobSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#999" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ mb: 1 }}
                  />
                  {jobSearchLoading ? (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 2 }}
                    >
                      <CircularProgress size={24} />
                    </Box>
                  ) : activeJobs.length > 0 ? (
                    <List
                      sx={{
                        maxHeight: 200,
                        overflow: "auto",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                      }}
                    >
                      {activeJobs.map((job) => (
                        <ListItemButton
                          key={job._id}
                          selected={selectedJob?._id === job._id}
                          onClick={() => handleSelectExistingJob(job)}
                          sx={{
                            borderBottom: "1px solid #f0f0f0",
                            "&:hover": {
                              backgroundColor: colors.primaryLight,
                              "& .MuiListItemText-primary": {
                                color: colors.primary,
                              },
                            },
                            "&.Mui-selected": {
                              backgroundColor: colors.primaryLight,
                              "& .MuiListItemText-primary": {
                                color: colors.primary,
                              },
                            },
                            "&.Mui-selected:hover": {
                              backgroundColor: colors.primaryLight,
                            },
                          }}
                        >
                          <ListItemText
                            primary={job.roleDesignation}
                            secondary={`${job.jobId} • ${job.company}`}
                            primaryTypographyProps={{
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                            secondaryTypographyProps={{ fontSize: "12px" }}
                          />
                        </ListItemButton>
                      ))}
                    </List>
                  ) : (
                    <Typography sx={{ fontSize: "13px", color: "#999", py: 1 }}>
                      {jobSearch ? "No jobs found" : "Type to search jobs"}
                    </Typography>
                  )}
                  {selectedJob && jobDescription && (
                    <Box
                      sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: "8px",
                        backgroundColor: colors.primaryLight,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: colors.primary,
                          fontWeight: 600,
                        }}
                      >
                        JD Loaded: {jobDescription.name}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setJobDescription(null);
                          setSelectedJob(null);
                          setResult([]);
                          setDetailedSummary(null);
                        }}
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              )}

              {jdMode === "upload" && (
                <Box>
                  <Typography className="upload-card__desc">
                    Upload JD (PDF/DOC/DOCX) to match candidates.
                  </Typography>
                  <Box className="dropzone" onClick={handleSelectPDF}>
                    <input
                      ref={pdfRef}
                      type="file"
                      className="input__pdf"
                      onChange={handleFileChange}
                      accept=".pdf, .docx, .doc"
                    />
                    <CloudUploadIcon sx={{ fontSize: 32, color: colors.primary }} />
                    <Typography className="dropzone__text">
                      Drop file here
                    </Typography>
                    <Typography className="dropzone__hint">
                      PDF, DOC or DOCX, up to 10 MB
                    </Typography>
                    <Button className="upload-btn" variant="contained">
                      Upload JD
                    </Button>
                  </Box>
                  {jobDescription && (
                    <Box
                      sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: "8px",
                        backgroundColor: colors.primaryLight,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          color: colors.primary,
                          fontWeight: 600,
                        }}
                      >
                        JD Loaded: {jobDescription.name}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setJobDescription(null);
                          setResult([]);
                          setDetailedSummary(null);
                        }}
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              )}
            </Box>

            <Box className="upload-card" sx={{ justifyContent: "center" }}>
              <Box className="upload-card__header">
                <CloudUploadIcon sx={{ fontSize: 22, color: colors.primary }} />
                <Typography className="upload-card__heading">
                  Resumes
                </Typography>
              </Box>
              <Typography className="upload-card__desc">
                Bulk upload resumes for automatic scoring
              </Typography>
              <Box
                className="dropzone dropzone--resume"
                onClick={handleOpenResume}
                sx={{ mt: 4 }}
              >
                <input
                  ref={resumeRef}
                  type="file"
                  multiple={true}
                  className="input__pdf"
                  onChange={handleSelectResume}
                  accept=".pdf, .docx, .doc"
                />
                <CloudUploadIcon sx={{ fontSize: 32, color: colors.primary }} />
                <Typography className="dropzone__text">
                  Drop files here
                </Typography>
                <Typography className="dropzone__hint">
                  PDF, DOC or DOCX — multiple files OK
                </Typography>
                <Button
                  className="upload-btn upload-btn--resume"
                  variant="contained"
                >
                  Bulk Upload
                </Button>
              </Box>
              {resume?.length > 0 && (
                <Box className="resume-list-wrapper">
                <Grid container spacing={1.5}>
                  {resume.map((data, index) => (
                    <Grid item md={resume.length === 1 ? 12 : 6} xs={12} key={index}>
                      <Box
                        sx={{
                          p: 1.5,
                          borderRadius: "8px",
                          backgroundColor: colors.primaryLight,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: colors.primary,
                            fontWeight: 600,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {data.name}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveResume(index);
                            setResult([]);
                            setDetailedSummary(null);
                          }}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
                </Box>
              )}
            </Box>
          </Box>

          <Box className="action-bar">
            <Button
              className="submit-btn"
              variant="contained"
              onClick={handleGenerateResult}
              startIcon={<AutoAwesomeIcon />}
            >
              Start AI Matching
            </Button>
          </Box>
          <Typography
            className="heading__secondary"
            variant="h5"
            fontWeight="bold"
            gutterBottom
            marginTop={"20px"}
          ></Typography>
          {result?.length > 0 && (
            <div ref={resultSectionRef}>
              {category === "match_resume" ? (
                <Stack
                  justifyContent={"space-between"}
                  direction={"row"}
                  alignItems={"center"}
                >
                  <Typography
                    className="heading__secondary"
                    variant="h5"
                    fontWeight="bold"
                    gutterBottom
                  >
                    Matching all Resumes
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    {selectedCandidates.length > 0 && jdMode === "select" && (
                      <Button
                        className="download_btn"
                        onClick={handleSaveSelected}
                        startIcon={
                          savingCandidates ? (
                            <CircularProgress
                              size={16}
                              sx={{ color: "#fff" }}
                            />
                          ) : (
                            <BookmarkIcon />
                          )
                        }
                        disabled={savingCandidates}
                      >
                        Save Selected ({selectedCandidates.length})
                      </Button>
                    )}
                    {selectedCandidates.length > 0 && jdMode === "upload" && (
                      <Autocomplete
                        size="small"
                        options={uploadModeJobs}
                        getOptionLabel={(option) =>
                          `${option.jobId} — ${option.roleDesignation}`
                        }
                        loading={uploadModeJobLoading}
                        onInputChange={(_, value) =>
                          setUploadModeJobSearch(value)
                        }
                        onChange={(_, value) => {
                          if (value) handleUploadModeSaveWithJob(value);
                        }}
                        disabled={savingCandidates}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Job ID to save"
                            sx={{
                              minWidth: 280,
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                              },
                            }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    {savingCandidates ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <BookmarkIcon
                                        sx={{
                                          fontSize: 18,
                                          color: colors.primary,
                                        }}
                                      />
                                    )}
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                              endAdornment: (
                                <>
                                  {uploadModeJobLoading ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={18}
                                    />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <MenuItem
                            {...props}
                            sx={{
                              "&:hover": {
                                backgroundColor: `${colors.primary} !important`,
                                color: "#fff",
                                "& .job-sub-text": {
                                  color: "#fff !important",
                                },
                              },
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{ fontSize: "13px", fontWeight: 600 }}
                              >
                                {option.jobId}
                              </Typography>
                              <Typography
                                className="job-sub-text"
                                sx={{ fontSize: "12px", color: "#637381" }}
                              >
                                {option.roleDesignation} • {option.company}
                              </Typography>
                            </Box>
                          </MenuItem>
                        )}
                      />
                    )}
                    <Button
                      className="download_btn"
                      onClick={() => {
                        downloadResumeListMutation.mutate(jdResumeSessionId);
                      }}
                      startIcon={<CloudDownloadIcon />}
                    >
                      Download
                    </Button>
                  </Box>
                </Stack>
              ) : (
                <Typography
                  className="heading__secondary"
                  variant="h5"
                  fontWeight="bold"
                  gutterBottom
                >
                  Top Resumes
                </Typography>
              )}
              <TableContainer
                className="custom-scrollbar"
                style={{ maxHeight: 500 }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          bgcolor: colors.primary,
                          padding: "6px 12px",
                          width: "48px",
                        }}
                      >
                        <Checkbox
                          size="small"
                          checked={
                            result.length > 0 &&
                            selectedCandidates.length === result.length
                          }
                          indeterminate={
                            selectedCandidates.length > 0 &&
                            selectedCandidates.length < result.length
                          }
                          onChange={handleToggleAllCandidates}
                          sx={{
                            color: "#ffffff",
                            "&.Mui-checked": { color: "#ffffff" },
                            "&.MuiCheckbox-indeterminate": { color: "#ffffff" },
                          }}
                        />
                      </TableCell>
                      {headCells.map((headCell, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontWeight: "bold",
                            bgcolor: colors.primary,
                            color: "#ffffff",
                            textAlign: "center",
                            padding: "12px",
                            fontSize: "13px",
                            minWidth: headCell.width || "auto",
                          }}
                        >
                          {headCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {result.length > 0 &&
                      result.map((resume, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ padding: "6px 12px" }}>
                            <Checkbox
                              size="small"
                              checked={selectedCandidates.includes(index)}
                              onChange={() => handleToggleCandidate(index)}
                              sx={{
                                color: colors.primary,
                                "&.Mui-checked": { color: colors.primary },
                              }}
                            />
                          </TableCell>
                          <TableCell
                            className={getTableRowColor(
                              resume["Percentage Matching"],
                            )}
                          >
                            {resume["Full Name"]}
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography
                                textAlign={"center"}
                                className={getTableRowColor(
                                  resume["Percentage Matching"],
                                )}
                              >
                                {resume.Email}
                              </Typography>
                              <Typography
                                textAlign={"center"}
                                className={getTableRowColor(
                                  resume["Percentage Matching"],
                                )}
                              >
                                {resume["Phone Number"]}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            className={getTableRowColor(
                              resume["Percentage Matching"],
                            )}
                          >
                            {Array.isArray(resume.Experience) ? (
                              <Box
                                component="ul"
                                sx={{
                                  m: 0,
                                  pl: 2,
                                  "& li": { mb: 0.5, fontSize: "12px" },
                                }}
                              >
                                {resume.Experience.map((exp, i) => (
                                  <li key={i}>{exp}</li>
                                ))}
                              </Box>
                            ) : (
                              resume.Experience
                            )}
                          </TableCell>
                          <TableCell
                            className={getTableRowColor(
                              resume["Percentage Matching"],
                            )}
                          >
                            {Array.isArray(resume.Skills) ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 0.5,
                                }}
                              >
                                {resume.Skills.map((skill, i) => (
                                  <Chip
                                    key={i}
                                    label={skill}
                                    size="small"
                                    sx={{
                                      fontSize: "11px",
                                      height: "22px",
                                      bgcolor: "#e8f0fe",
                                      color: colors.primary,
                                    }}
                                  />
                                ))}
                              </Box>
                            ) : (
                              resume.Skills
                            )}
                          </TableCell>
                          <TableCell
                            className={getTableRowColor(
                              resume["Percentage Matching"],
                            )}
                          >
                            {Array.isArray(resume.Education) ? (
                              <Box
                                component="ul"
                                sx={{
                                  m: 0,
                                  pl: 2,
                                  "& li": { mb: 0.5, fontSize: "12px" },
                                }}
                              >
                                {resume.Education.map((edu, i) => (
                                  <li key={i}>{edu}</li>
                                ))}
                              </Box>
                            ) : (
                              resume.Education
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Chip
                              label={`${resume["Percentage Matching"]}%`}
                              size="small"
                              sx={{
                                fontWeight: 700,
                                fontSize: "13px",
                                bgcolor:
                                  Number(resume["Percentage Matching"]) >= 75
                                    ? "#e6f4ea"
                                    : Number(resume["Percentage Matching"]) >=
                                      60
                                    ? "#fef7e0"
                                    : "#fce8e8",
                                color:
                                  Number(resume["Percentage Matching"]) >= 75
                                    ? "#1e7e34"
                                    : Number(resume["Percentage Matching"]) >=
                                      60
                                    ? "#b8860b"
                                    : "#d32f2f",
                                border: "1px solid",
                                borderColor:
                                  Number(resume["Percentage Matching"]) >= 75
                                    ? "#a3d9a5"
                                    : Number(resume["Percentage Matching"]) >=
                                      60
                                    ? "#f0d58c"
                                    : "#f5a5a5",
                              }}
                            />
                          </TableCell>

                          <TableCell
                            className={getTableRowColor(
                              resume["Percentage Matching"],
                            )}
                          >
                            <Box
                              sx={{
                                color:
                                  Number(resume["Percentage Matching"]) >= 60
                                    ? "green"
                                    : "#d61515",
                                "& p": { margin: 0 },
                              }}
                            >
                              {resume["Matching Explanation"]?.length > 100 ? (
                                <>
                                  <ReactMarkdown>
                                    {`${resume["Matching Explanation"].slice(
                                      0,
                                      100,
                                    )}...`}
                                  </ReactMarkdown>
                                  <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => {
                                      handleMatchingExplanation(
                                        resume["Matching Explanation"],
                                        resume["Matching Recommendation"],
                                      );
                                    }}
                                    sx={{ marginLeft: 1 }}
                                  >
                                    Read More
                                  </Link>
                                </>
                              ) : (
                                <ReactMarkdown>
                                  {resume["Matching Explanation"] || ""}
                                </ReactMarkdown>
                              )}
                            </Box>
                          </TableCell>

                          <TableCell>
                            <Chip
                              label="Generate"
                              className="pointer--hover"
                              onClick={() =>
                                handleGetDetailedResume(
                                  resume.candidate_id,
                                  jdResumeSessionId,
                                )
                              }
                              sx={{
                                bgcolor: colors.primary,
                                color: "#ffffff",
                                fontWeight: "bold",
                                "&:hover": {
                                  bgcolor: colors.primaryHover,
                                },
                                cursor: "pointer",
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* </ThemeProvider> */}
            </div>
          )}
          {detailedSummary && (
            <Box mt={4}>
              <Divider sx={{ mb: 3 }} />
              <Typography
                id="summary__heading"
                variant="h5"
                fontWeight="700"
                gutterBottom
                sx={{
                  color: colors.primary,
                  mb: 2,
                }}
              >
                Candidate Detailed Profile
              </Typography>
              <CandidateSummary data={detailedSummary} />
            </Box>
          )}
        </Box>
      )}
      {tab === "create_jd" && (
        <CreateNewJobDescription
          handleCreateNewJD={handleCreateNewJD}
          handleSetNewJDDescription={handleSetNewJDDescription}
          jdDetails={jdDetails}
          newJDDescriptions={newJDDescriptions}
          jdLevel={jdLevel}
          yearExperiencesList={yearExperiencesList}
          setjdLevel={setjdLevel}
          years={years}
          level={level}
          setyearExperiencesList={setyearExperiencesList}
          handleSetLocation={handleSetLocation}
          year={year}
          setYear={setYear}
        />
      )}
    </HomeContainer>
  );
};

export default Home;
